import PropTypes from 'prop-types'
import { ARM_MORTGAGE_TYPE, FIX_MORTGAGE_TYPE } from 'src/constants/loan'

export const baseProps = {
  type: PropTypes.oneOf([ARM_MORTGAGE_TYPE, FIX_MORTGAGE_TYPE]),
  years: PropTypes.number.isRequired
}

export const deltaProps = {
  longterm: PropTypes.number.isRequired,
  shortterm: PropTypes.number.isRequired
}

export const PMI = PropTypes.number
